/* eslint-disable no-sequences */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-debugger */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable no-mixed-operators */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-unused-vars */
/* eslint-disable react/button-has-type */
/* eslint-disable max-len */
import { motion } from 'framer-motion';
import React, { useState, useEffect, useCallback } from 'react';
import ReactModal from 'react-modal';
import { Link } from 'react-router-dom';
import { DebounceInput } from 'react-debounce-input';
import debounce from 'lodash.debounce';
import CategoryToolTip from '../../../Components/CategoryToolTip';
import OfferToolTip from '../../../Components/OfferToolTip';
import { PriceHandler } from '../../../redux/helper/CamelCase';
import { ExpectedDateGenerator } from '../../../redux/helper/DateConverter';
import AddressChangeModal from './AddressChangeModal';
import AddressHover from './AddressChangeModal/AddressHover';
import { CDN } from '../../../constants';
import { distributorService } from '../../../service/distributor.service';
import ItemPriceTooltip from '../../../Components/ItemPriceTooltip';

export default function ProductCard({
    prod, OrderDetails,
    setOrderDetails,
    addressDropdown,
    GroupCategory,
    setThreePlPopup,
    handleUpdateAddress,
    setGroupCategoryValue,
    groupIdx,
    handleRevisedPrice,
    UserRole,
    setItemLevel3pl,
    handleFetch,

}) {
    const [addresmodal, setaddresmodal] = useState('');
    const [addressPopup, setaddressPopup] = useState(false);
    const [OfferhoverId, setOfferhoverId] = useState('');
    const [discount, setdiscount] = useState(prod.trade_discount);
    const [TypeToggle, setTypeToggle] = useState('₹');
    const [revisedPrice, setrevisedPrice] = useState('');
    const [totalPricehoverId, setTotalitemPricehoverId] = useState('');
    const [subTotalPricehoverId, setSubTotalPricehoverId] = useState('');
    const [proposedValuehoverId, setProposedValuehoverId] = useState('');
    const [revisedValuehoverId, setRevisedValuehoverId] = useState('');
    const handleImage = (img) => (img ? `${CDN}/product-images/${img}` : '/images/gen.png');
    const [hoverId, sethoverId] = useState('');
    useEffect(() => {
        if (['Trade', 'Trade EUB'].includes(OrderDetails?.order_type)) {
            setTypeToggle(prod?.revised_type === '₹' ? '₹' : '%');
            setrevisedPrice(prod.revised_price);
        } else {
            setTypeToggle(prod?.trade_discount_type === '₹' ? '₹' : '%');
            setrevisedPrice(prod.trade_discount);
        }
    }, []);
    const debouncedSave = useCallback(
        debounce((payload) => {
            handleRevisedPrice(payload);
        }, 1000),
        [],
    );

    const setProposedPrice = (val, type) => {
        let amount = 0;
        if (val !== '') {
            if (Number(val) < Number(prod.total_price)) {
                amount = Number(val);
            }
        }
        const payload = {
            item_id: prod.item_id,
            revised_price: amount,
            revised_type: type || TypeToggle,
        };
        debouncedSave(payload);
    };

    const handleTypeToggle = (type) => {
        setTypeToggle(type);
        // const obj={...proposedCount}
        if (type === '%' && Number(revisedPrice) > 99.99) {
            setrevisedPrice(0, type);
            setProposedPrice(0, type);
        } else {
            setProposedPrice(revisedPrice, type);
        }
        if (type === '%') {
            setdiscount(0);
        }
    };
    const handleDisable = () => {
        const arr = ['copec', 'regional_sales_manager'];
        return !arr.includes(UserRole);
    };
    const handleAddress = () => {
        const arr = ['copec', 'regional_sales_manager'];
        const currentRole = JSON.parse(localStorage.getItem('user')).profile.roles;
        return !arr.includes(UserRole);
    };

    const handlePrice = async (val, type) => {
        if (val !== '') {
            const { items, instruction } = OrderDetails;
            const category = Object.keys(items).length > 0 ? Object.keys(items)[0] : instruction;
            const index = items[category].findIndex((p) => p.INVENTORY_ITEM_ID === prod.INVENTORY_ITEM_ID);
            if (index >= 0) {
                items[category][index].trade_discount_type = type;
                items[category][index].trade_discount = val;
            }
            const res = await distributorService.OrderStatusUpdate({ items }, OrderDetails.distributor_id, OrderDetails.order_number);
            if (!res.error && res.data.success_status) {
                handleFetch();
            } else {
                // console.log(res?.message?.response?.data?.message);
            }
        }
    };
    const checkWarning = () => (OrderDetails?.order_type === 'Domestic' && prod.max_discount_error === true && OrderDetails.approvals.next_approval !== 'copec');
    return (
        <div className={`rounded-lg bg-[#FFFFFF] shadow-s7 px-4 pb-0 pt-4 relative mt-2 mb-1.5 ${checkWarning() === true ? 'border-2 border-[#E29300]' : ''}`}>
            <div className="flex flex-wrap">
                <div className="w-full pt-2">
                    <div className="flex ">
                        <div className="sm:w-1/4 w-[20%]">
                            <Link to={`/products/${prod.INVENTORY_ITEM_ID}/view`}>
                                <motion.img
                                    initial={{ opacity: 0, scale: 0.6 }}
                                    animate={{ opacity: 1, scale: 1 }}
                                    transition={{
                                        duration: 0.8,
                                        delay: 0.5,
                                        ease: [0, 0.71, 0.2, 1.01],
                                    }}
                                    src={handleImage(prod?.IMAGE_NAME)}
                                    alt="icon"
                                    className="w-full"
                                />
                            </Link>
                        </div>
                        <div className="pl-2.5 sm:w-full">
                            <div className="flex justify-between items-center">
                                <div className="flex sm:items-center items-start sm:flex-row flex-col">
                                    <Link to={`/products/${prod.INVENTORY_ITEM_ID}/view`}><p className="sm:text-xl text-base font-bold text-[#090406] pr-3">{prod?.MODEL_DESCRIPTION?.slice(0, 20) || `${prod?.DESCRIPTION.length > 10 ? `${prod.DESCRIPTION.slice(0, 10)}...` : `${prod.DESCRIPTION}`}`}</p></Link>
                                    <p className="text-xs font-semibold text-[#FFFFFF] bg-[#44445E] rounded px-1.5 py-1 w-fit sm:mt-0 mt-1">{prod?.MAIN_CATEGORY}</p>
                                </div>
                                <div className="flex items-center">
                                    <p className="text-xs font-normal text-[#777777]">3PL Location</p>
                                    <button
                                        onClick={() => {
                                            setThreePlPopup(prod.item_id);
                                            setGroupCategoryValue(Object.keys(OrderDetails.items)[groupIdx]);
                                            setItemLevel3pl(prod);
                                        }}
                                        disabled={handleDisable() || Object(OrderDetails.approvals).hasOwnProperty(UserRole)}
                                        type="button"
                                        className="border border-[#777777] min-w-[118px] h-7 rounded-md ml-2.5 bg-[#FFFFFF] text-xs6 font-normal text-[#303030] px-2.5"
                                        data-bs-toggle="modal"
                                        data-bs-target="#change3PL"
                                    >
                                        <span className="flex">{prod['3pl']?.DESCRIPTION}</span>
                                    </button>
                                </div>
                            </div>
                            <div className="flex justify-between items-center w-full">
                                <div className="w-[70%]">
                                    <p className="sm:text-xs6 text-xs2 font-normal text-[#808285] mt-1">
                                        <span>
                                            Product Code:
                                            {' '}
                                            {prod?.CONCATENATED_SEGMENTS}
                                        </span>
                                        <span className="sm:px-4 px-2">|</span>
                                        <span>
                                            AWS Classification:
                                            {' '}
                                            {prod?.AWS_CLASSIFICATION}
                                        </span>
                                    </p>
                                </div>
                                <div className="w-fit pt-1.5">
                                    <div className="flex justify-end w-fit">
                                        <p className="sm:text-xs6 text-xs2 font-normal text-[#808285] bg-[#F5F5FA] rounded-[3px] px-2.5 py-[7px] w-fit xl:mb-0 mb-3">
                                            Stock:
                                            {' '}
                                            <span className="text-[#424446] font-semibold">
                                                <span className="text-[#424446] font-semibold">
                                                    {prod?.STOCK_ONHAND_QTY}
                                                    {' '}
                                                    {prod?.PRIMARY_UOM_CODE}
                                                </span>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-2 flex sm:items-center items-baseline sm:flex-row flex-col">
                                <div className="flex sm:border-r sm:border-[#707070] sm:pr-[6px] w-fit items-center">
                                    <p className="text-xs font-semibold text-[090406]">Category</p>
                                    <p className="text-xs3 font-semibold text-white px-1 bg-[#555259] rounded-[3px] w-fit mx-1.5">A</p>
                                    <button data-tooltip-target="tooltip-information" data-tooltip-placement="left" data-tooltip-trigger="click" type="button">
                                        <img
                                            src="/images/info_icon.svg"
                                            alt="icon"
                                            className="cursor-pointer"
                                            onMouseEnter={() => {
                                                setTimeout(() => {
                                                    sethoverId(prod.INVENTORY_ITEM_ID);
                                                }, 1000);
                                            }}
                                            onMouseLeave={() => {
                                                setTimeout(() => {
                                                    sethoverId('');
                                                }, 2000);
                                            }}
                                        />
                                    </button>
                                    {hoverId === prod.INVENTORY_ITEM_ID && (
                                        <CategoryToolTip hover={hoverId === prod.INVENTORY_ITEM_ID} />
                                    )}
                                </div>
                                <p className="text-xs font-semibold text-[#808285] sm:px-[6px] sm:border-r sm:border-[#707070] sm:pt-0 pt-1">
                                    Expected Dispatch:
                                    {' '}
                                    <span className="font-bold text-[#555259]">{prod.DELIVERY_LEAD_TIME ? ExpectedDateGenerator(prod?.DELIVERY_LEAD_TIME) : '-'}</span>
                                </p>

                                <p className="text-xs3 font-semibold text-[#808285] sm:pl-[6px] sm:pt-0 pt-1">
                                    Method of Packing:
                                    {' '}
                                    <span className="font-bold text-[#555259]">{prod?.METHOD_OF_PACKING}</span>
                                </p>
                            </div>
                            <p className="font-normal text-xs text-[#808285] mt-2.5">{prod?.DESCRIPTION}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="w-full lg:px-2 mt-2.5 mb-3.5">
                <div className="flex items-center xl:flex-row flex-col">
                    <div className="xl:w-[50%] w-full pl-4 pr-2 pb-2 pt-2.5 bg-[#F5F5FA] rounded-lg flex flex-wrap justify-start xl:mr-2.5">
                        <div className="pr-2 border-r border-[#CECECE] xl:w-auto sm:w-1/3 w-1/2">
                            <p className="text-xs font-semibold text-[#808285]">Standard Pack Size</p>
                            <p className="sm:text-xs6 text-sm font-semibold text-[#555259]">
                                {prod?.PACKING_SIZE}
                                {' '}
                                {prod?.PRIMARY_UOM_CODE}
                            </p>
                        </div>
                        <div className="px-2 sm:border-r border-[#CECECE] xl:w-auto sm:w-1/3 w-1/2">
                            <p className="text-xs font-semibold text-[#808285]">Size</p>
                            {prod?.MAIN_CATEGORY !== 'EQUIPMENT' ? (
                                <p className="sm:text-xs6 text-sm font-semibold text-[#555259]">
                                    {`${prod.DIAMETER !== null ? `${prod.DIAMETER}mm` : ''}`}
                                    {`${prod.LENGTH !== null && prod.DIAMETER ? 'x' : ''}`}
                                    {`${prod.LENGTH !== null ? `${prod.LENGTH}mm` : ''}`}
                                    {prod.LENGTH === null && prod.DIAMETER === null ? '-' : ''}

                                </p>
                            ) : (
                                <p className="sm:text-xs6 text-sm font-semibold text-[#555259]">
                                    -

                                </p>
                            )}
                        </div>
                        <div className="sm:pl-2 pt-2 sm:pt-0">
                            <p className="text-xs font-semibold text-[#808285]">MOQ</p>
                            <p className="sm:text-xs6 text-sm font-semibold text-[#555259]">{prod?.MINIMUM_ORDER_QUANTITY || 1}</p>
                        </div>
                    </div>
                    <div className="xl:w-[50%] w-full flex sm:nowrap  flex-wrap justify-start px-4 pt-2.5 pb-2 shadow-s9 rounded-lg xl:mt-0 mt-3 relative">
                        <button
                            onClick={() => {
                                if (addresmodal !== '') {
                                    setaddresmodal('');
                                } else {
                                    setaddresmodal('billing');
                                }
                            }}
                            type="button"
                            className="pr-2 border-r border-[#CECECE] xl:auto sm:w-1/2 w-full flex justify-between items-center text-left showAddress-full45 "
                        >
                            <div className="w-[82%]">
                                <p className="text-xs font-semibold text-[#808285]">Billing address</p>
                                <p className="text-xs6 font-semibold text-[#555259] more-lines">
                                    {prod?.BILLING_ADDRESS?.ADDRESS1}
                                    ,
                                    {prod?.BILLING_ADDRESS?.ADDRESS2}

                                </p>
                                {' '}

                            </div>
                            <p className="font-semibold text-xs12 text-[#808285] cursor-pointer w-[18%]">
                                {!handleAddress() ? 'Change' : 'View'}

                            </p>
                        </button>
                        {addresmodal === 'billing' && (
                            <AddressHover
                                address={prod.BILLING_ADDRESS}
                                type={addresmodal}
                                setaddressPopup={setaddressPopup}
                                setGroupCategoryValue={setGroupCategoryValue}
                                groupIdx={groupIdx}
                                OrderDetails={OrderDetails}
                                UserRole={UserRole}
                            />
                        )}
                        <button
                            onClick={() => {
                                if (addresmodal !== '') {
                                    setaddresmodal('');
                                } else {
                                    setaddresmodal('shipping');
                                }
                            }}
                            className="sm:px-2 px-0 xl:auto sm:w-1/2 w-full text-left sm:mt-0 mt-2 flex justify-between items-center relative"
                        >
                            <div className="w-[85%]">
                                <p className="text-xs font-semibold text-[#808285]">Shipping address</p>
                                <p className="text-xs6 font-semibold text-[#555259] more-lines">
                                    {prod?.SHIPPING_ADDRESS?.ADDRESS1}
                                    ,
                                    {' '}
                                    {prod?.SHIPPING_ADDRESS?.ADDRESS2}

                                </p>
                                <p>{}</p>

                            </div>
                            <p className="font-semibold text-xs12 text-[#808285] cursor-pointer w-[18%]">{!handleAddress() ? 'Change' : 'View'}</p>

                            {addresmodal === 'shipping' && (
                                <AddressHover
                                    address={prod.SHIPPING_ADDRESS}
                                    type={addresmodal}
                                    setaddressPopup={setaddressPopup}
                                    setGroupCategoryValue={setGroupCategoryValue}
                                    groupIdx={groupIdx}
                                    OrderDetails={OrderDetails}
                                    UserRole={UserRole}
                                />
                            )}

                        </button>
                        {/* <!-- <div class="sm:pl-2 pt-2 sm:pt-0">
                                            <p class="text-xs font-semibold text-[#808285]">DAP</p>
                                            <p class="text-xs6 font-semibold text-[#555259] more-lines">₹20,000.00</p>
                                        </div> --> */}
                    </div>
                </div>
            </div>
            <div className="w-full flex lg:flex-row flex-col border-[#CBCBCB] py-3 border-t">
                <div className="lg:w-[30%] w-full flex flex-wrap justify-between items-center">
                    <div className="pb-5">
                        <p className="text-xs3 font-semibold text-[#808285]">List Price</p>
                        <p className="md:text-xs10 sm:text-lg text-base font-semibold text-[#15090E]">{PriceHandler(Number(prod?.LIST_PRICE))}</p>
                    </div>
                    <div className="ml-2.5 pb-5">
                        <p className="text-xs3 font-semibold text-[#808285] text-start mr-[17px]">Quantity</p>
                        <p className="md:text-xs10 sm:text-lg text-base font-semibold text-[#15090E]">
                            {prod?.quantity}
                            {' '}
                            {prod?.PRIMARY_UOM_CODE}

                        </p>
                    </div>
                    {['Trade', 'Trade EUB'].includes(OrderDetails?.order_type)
                        ? (
                            <div className="pb-5">
                                <p className="text-xs3 font-semibold text-[#808285] text-start mr-[17px]">Discount</p>
                                <p className="md:text-xs10 sm:text-lg text-base font-semibold text-[#15090E]">
                                    {PriceHandler(Number(prod?.discount_applied))}
                                    <span className="ml-1">
                                        <button
                                            onMouseLeave={() => {
                                                setTimeout(() => {
                                                    setOfferhoverId('');
                                                }, 500);
                                            }}
                                            onMouseEnter={() => {
                                                setTimeout(() => {
                                                    setOfferhoverId(prod.INVENTORY_ITEM_ID);
                                                }, 500);
                                            }}
                                            data-tooltip-target="tooltip-discountPrice"
                                            data-tooltip-placement="left"
                                            data-tooltip-trigger="click"
                                            type="button"
                                        >
                                            <img src="/images/info-filled_icon.svg" alt="icon" className="cursor-pointer" />
                                        </button>
                                        {OfferhoverId !== '' && <OfferToolTip hover={OfferhoverId === prod.INVENTORY_ITEM_ID} prod={prod} OrderDetails={OrderDetails} />}
                                    </span>
                                </p>
                            </div>
                        )
                        : (
                            <div className="flex items-center justify-between w-full xl:mt-0 mt-4">
                                <div>
                                    <p className="text-xs3 font-semibold mb-2 text-[#808285]">Discount</p>
                                    {['regional_sales_manager', 'sales_head', 'area_sales_manager'].includes(UserRole)
                                        ? (
                                            <div className="flex">
                                                <ul className="nav nav-pills flex border border-[#555259] rounded-[5px]" id="pills-tabVertical" role="tablist">
                                                    <li onClick={() => handleTypeToggle('₹')} className="nav-item flex-grow text-center ml-[-1px]" role="presentation">
                                                        <a href="javascript:void(0)" className={`nav-link block ${TypeToggle === '₹' ? 'active' : ''} offer-currency font-semibold text-[#555259] text-xs19 w-[30px] rounded-[5px]`} id="pill1" data-bs-toggle="pill" data-bs-target="#home1" role="tab" aria-controls="home1" aria-selected="true">
                                                            ₹
                                                        </a>
                                                    </li>
                                                    <li onClick={() => handleTypeToggle('%')} className="nav-item flex-grow text-center mr-[-1px]" role="presentation">
                                                        <a href="javascript:void(0)" className={`nav-link block offer-currency ${TypeToggle === '%' ? 'active' : ''} font-bold text-[#555259] text-xs19 w-[30px] rounded-[5px]`} id="pill2" data-bs-toggle="pill" data-bs-target="#home2" role="tab" aria-controls="home2" aria-selected="true">
                                                            %
                                                        </a>
                                                    </li>
                                                </ul>
                                                <div className="tab-content" id="pills-tabContentVertical">
                                                    <div
                                                        className="tab-pane fade  active"
                                                        id="home1"
                                                        role="tabpanel"
                                                        aria-labelledby="pill1"
                                                    >
                                                        <input
                                                            minLength={1}
                                                            onScroll={(e) => e.preventDefault()}
                                                            onWheel={(e) => e.target.blur()}
                                                            onKeyDown={(event) => {
                                                                if (event.key === 'ArrowDown' || event.key === 'ArrowUp') return event.preventDefault();
                                                                return true;
                                                            }}
                                                            type="text"
                                                            value={discount}
                                                            className="w-full h-7 border border-[#808285] rounded-lg outline-0 sm:text-xs9 text-xs6 font-semibold text-[#090406] text-right appearance-none"
                                                            onChange={(e) => {
                                                                if (Number(e.target.value) > -1 && (TypeToggle === '%' && e.target.value < 100) || (TypeToggle === '₹' && e.target.value < Number(prod.total_price))) {
                                                                    if ((TypeToggle === '%' && e.target.value.match(/^(\d*\.{0,1}\d{0,2}$)/)) || TypeToggle === '₹') {
                                                                        setdiscount(e.target.value);
                                                                        handlePrice(e.target.value, TypeToggle);
                                                                    }
                                                                } else {
                                                                    setdiscount(0);
                                                                    handlePrice(e.target.value, TypeToggle);
                                                                }
                                                            }}
                                                        />
                                                    </div>

                                                </div>
                                            </div>
                                        ) : (
                                            <p className="md:text-xs10 sm:text-lg text-base font-semibold text-[#15090E]">
                                                {PriceHandler(prod?.trade_discount_applied)}
                                            </p>
                                        )}
                                </div>
                            </div>
                        )}
                    {['Trade', 'Trade EUB'].includes(OrderDetails?.order_type)
                    && (

                        <div className="ml-2.5 pb-5">
                            <p className="text-xs3 font-semibold text-[#808285] text-start mr-[17px]">DAP </p>
                            <p className="md:text-xs10 sm:text-lg text-base font-semibold text-[#15090E]">
                                {PriceHandler(prod?.dap)}

                            </p>
                        </div>

                    )}
                </div>
                <div className="lg:w-[70%] w-full lg:ml-8 ml-0 mr-4">
                    <div className={OrderDetails?.order_type !== 'Trade EUB' ? '' : 'flex'}>
                        <div className={OrderDetails?.order_type === 'Trade EUB' ? 'w-1/2 px-2' : 'px-2'}>
                            <button className="w-full bg-[#F5F5FA] rounded-lg text-center p-2">
                                <p className="text-xs2 font-semibold text-[#808285]">{!['Trade', 'Trade EUB'].includes(OrderDetails?.order_type) ? 'Sub Total' : 'Net Value'}</p>
                                <div className="flex justify-center items-center pl-1">
                                    <p className="md:text-xs4 text-base font-semibold text-[#15090E] mr-1 sm:pt-0.5">{PriceHandler(!['Trade', 'Trade EUB'].includes(OrderDetails?.order_type) ? Number(prod?.sub_total) : (Number(prod?.sub_total) - Number(prod?.discount_applied)))}</p>
                                    <span>
                                        <button
                                            className="mt-2"
                                            data-tooltip-target="tooltip-discountPercentage"
                                            data-tooltip-placement="right"
                                            data-tooltip-trigger="click"
                                            type="button"
                                            onMouseEnter={() => {
                                                setTimeout(() => {
                                                    setSubTotalPricehoverId(prod.INVENTORY_ITEM_ID);
                                                }, 100);
                                            }}
                                            onMouseLeave={() => {
                                                setTimeout(() => {
                                                    setSubTotalPricehoverId('');
                                                }, 2000);
                                            }}
                                        >
                                            <img src="/images/info-filled_icon.svg" alt="icon" className="cursor-pointer w-[14px] h-[14px]" />
                                        </button>
                                        {
                                            subTotalPricehoverId === prod.INVENTORY_ITEM_ID && (
                                                <ItemPriceTooltip hover={subTotalPricehoverId === prod.INVENTORY_ITEM_ID} prod={prod} itemPriceValue={(!['Trade', 'Trade EUB'].includes(OrderDetails?.order_type) ? Number(prod?.sub_total) : (Number(prod?.sub_total) - Number(prod?.discount_applied))) / prod.quantity} />
                                            )
                                        }
                                        <ItemPriceTooltip prod={prod} itemPriceValue={(!['Trade', 'Trade EUB'].includes(OrderDetails?.order_type) ? Number(prod?.sub_total) : (Number(prod?.sub_total) - Number(prod?.discount_applied))) / prod.quantity} />
                                    </span>
                                </div>
                            </button>
                        </div>
                        <div className={OrderDetails?.order_type === 'Trade EUB' ? 'w-1/2 px-2' : 'px-2 mt-2'}>
                            <button className="w-full bg-[#F5F5FA] rounded-lg text-center p-2">
                                <p className="text-xs2 font-semibold text-[#808285]">Total Price</p>
                                <div className="flex justify-center items-center pl-2">
                                    <p className="md:text-xs4 text-base font-semibold text-[#15090E] mr-1 sm:pt-0.5">{OrderDetails?.order_type !== 'Trade EUB' ? PriceHandler(Number(prod?.total_price)) : PriceHandler((Number(prod?.sub_total) - Number(prod?.discount_applied)) + Number(prod?.dap) - ((prod?.revised_price === undefined) ? Number(prod?.proposed_total_price) : Number(prod?.revised_total_price)))}</p>
                                    <span>
                                        <button
                                            className="mt-2"
                                            data-tooltip-target="tooltip-discountPercentage"
                                            data-tooltip-placement="right"
                                            data-tooltip-trigger="click"
                                            type="button"
                                            onMouseEnter={() => {
                                                setTimeout(() => {
                                                    setTotalitemPricehoverId(prod.INVENTORY_ITEM_ID);
                                                }, 100);
                                            }}
                                            onMouseLeave={() => {
                                                setTimeout(() => {
                                                    setTotalitemPricehoverId('');
                                                }, 2000);
                                            }}
                                        >
                                            <img src="/images/info-filled_icon.svg" alt="icon" className="cursor-pointer w-[14px] h-[14px]" />
                                        </button>
                                        {
                                            totalPricehoverId === prod.INVENTORY_ITEM_ID && (
                                                <ItemPriceTooltip hover={totalPricehoverId === prod.INVENTORY_ITEM_ID} prod={prod} itemPriceValue={(OrderDetails?.order_type !== 'Trade EUB' ? (Number(prod?.total_price)) : ((Number(prod?.sub_total) - Number(prod?.discount_applied)) + Number(prod?.dap) - ((prod?.revised_price === undefined) ? Number(prod?.proposed_total_price) : Number(prod?.revised_total_price)))) / prod.quantity} />
                                            )
                                        }
                                        <ItemPriceTooltip prod={prod} attribute="total_price" itemPriceValue={(OrderDetails?.order_type !== 'Trade EUB' ? (Number(prod?.total_price)) : ((Number(prod?.sub_total) - Number(prod?.discount_applied)) + Number(prod?.dap) - ((prod?.revised_price === undefined) ? Number(prod?.proposed_total_price) : Number(prod?.revised_total_price)))) / prod.quantity} />
                                    </span>
                                </div>
                            </button>
                        </div>
                    </div>
                    {OrderDetails?.order_type === 'Trade EUB' && (
                        <div className="flex mt-2 -mx-2 show-price-more1">
                            <div className="w-1/2 px-2">
                                <button className="w-full bg-[#F5F5FA] rounded-lg text-center p-2">
                                    <p className="text-xs2 font-semibold text-[#808285] show-price">Proposed Value</p>
                                    <div className="flex justify-center items-center pl-2">
                                        <p className="md:text-xs4 text-base font-semibold text-[#15090E] mr-1 sm:pt-0.5">
                                            {PriceHandler((Number(prod?.sub_total) - Number(prod?.discount_applied)) - Number(prod?.proposed_total_price))}
                                            {' '}
                                            (
                                            {prod.proposed_type === '%' ? `${prod?.proposed_amount} ${prod.proposed_type}` : `${prod.proposed_type} ${prod?.proposed_amount}` }
                                            )
                                        </p>
                                        <span>
                                            <button
                                                className="mt-2"
                                                data-tooltip-target="tooltip-discountPercentage"
                                                data-tooltip-placement="right"
                                                data-tooltip-trigger="click"
                                                type="button"
                                                onMouseEnter={() => {
                                                    setTimeout(() => {
                                                        setProposedValuehoverId(prod.INVENTORY_ITEM_ID);
                                                    }, 100);
                                                }}
                                                onMouseLeave={() => {
                                                    setTimeout(() => {
                                                        setProposedValuehoverId('');
                                                    }, 2000);
                                                }}
                                            >
                                                <img src="/images/info-filled_icon.svg" alt="icon" className="cursor-pointer w-[14px] h-[14px]" />
                                            </button>
                                            {
                                                proposedValuehoverId === prod.INVENTORY_ITEM_ID && (
                                                    <ItemPriceTooltip hover={proposedValuehoverId === prod.INVENTORY_ITEM_ID} prod={prod} itemPriceValue={((Number(prod?.sub_total) - Number(prod?.discount_applied)) - Number(prod?.proposed_total_price)) / prod.quantity} />
                                                )
                                            }
                                            <ItemPriceTooltip prod={prod} itemPriceValue={((Number(prod?.sub_total) - Number(prod?.discount_applied)) - Number(prod?.proposed_total_price)) / prod.quantity} />
                                        </span>
                                    </div>
                                </button>
                            </div>
                            {OrderDetails && UserRole === 'regional_sales_manager' && Number(OrderDetails.work_flow_status) < 2
                                ? (
                                    <div className="flex w-1/2 px-2">
                                        <div className="border border-[#D8DDE3] rounded-lg w-full relative px-3" style={{ pointerEvents: `${UserRole === 'regional_sales_manager' ? '' : 'none'}` }}>
                                            <p className="text-xs3 font-semibold text-[#808285] bg-[#FFFFFF] py-1">Revised Discount</p>
                                            <div className="flex">
                                                <ul className="nav nav-pills flex border border-[#555259] rounded-[5px]" id="pills-tabVertical" role="tablist">
                                                    <li onClick={() => handleTypeToggle('₹')} className="nav-item flex-grow text-center ml-[-1px]" role="presentation">
                                                        <a href="javascript:void(0)" className={`nav-link block ${TypeToggle === '₹' ? 'active' : ''} offer-currency font-semibold text-[#555259] text-xs19 w-[30px] rounded-[5px]`} id="pill1" data-bs-toggle="pill" data-bs-target="#home1" role="tab" aria-controls="home1" aria-selected="true">
                                                            ₹
                                                        </a>
                                                    </li>
                                                    <li onClick={() => handleTypeToggle('%')} className="nav-item flex-grow text-center mr-[-1px]" role="presentation">
                                                        <a href="javascript:void(0)" className={`nav-link block offer-currency ${TypeToggle === '%' ? 'active' : ''} font-bold text-[#555259] text-xs19 w-[30px] rounded-[5px]`} id="pill2" data-bs-toggle="pill" data-bs-target="#home2" role="tab" aria-controls="home2" aria-selected="true">
                                                            %
                                                        </a>
                                                    </li>
                                                </ul>
                                                <div className="tab-content" id="pills-tabContentVertical">
                                                    <div
                                                        className="tab-pane fade  active"
                                                        id="home1"
                                                        role="tabpanel"
                                                        aria-labelledby="pill1"
                                                    >
                                                        <input
                                                            minLength={1}
                                                            onWheel={(e) => e.target.blur()}
                                                            onKeyDown={(event) => {
                                                                if (event.key === 'ArrowDown' || event.key === 'ArrowUp') return event.preventDefault();
                                                                return true;
                                                            }}
                                                            type="number"
                                                            value={revisedPrice}
                                                            className="w-full font-normal text-lg text-[#000] outline-0 text-right appearance-none"
                                                            onChange={(e) => {
                                                                if (Number(e.target.value) > -1 && (TypeToggle === '%' && e.target.value < 100) || (TypeToggle === '₹' && e.target.value < Number(prod.total_price))) {
                                                                    setProposedPrice(e.target.value);
                                                                    setrevisedPrice(e.target.value);
                                                                } else {
                                                                    setProposedPrice(0);
                                                                    setrevisedPrice(0);
                                                                }
                                                            }}
                                                        />
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="w-1/2 px-2">
                                        <button className="w-full bg-[#F5F5FA] rounded-lg text-center p-2">
                                            <p className="text-xs2 font-semibold text-[#808285] show-price">Revised Value</p>
                                            <div className="flex justify-center items-center pl-2">
                                                <p className="md:text-xs4 text-base font-semibold text-[#15090E] mr-1 sm:pt-0.5">
                                                    { prod.revised_price === undefined ? 'Yet to be revised'
                                                        : `${PriceHandler((Number(prod?.sub_total) - Number(prod?.discount_applied)) - Number(prod?.revised_total_price))} 
                                        ${prod.revised_type === '%'
                                        ? `(${prod?.revised_price} ${prod.revised_type})`
                                        : `(${prod.revised_type} ${prod?.revised_price})`}`}

                                                </p>
                                                <span>
                                                    <button
                                                        className="mt-2"
                                                        data-tooltip-target="tooltip-discountPercentage"
                                                        data-tooltip-placement="right"
                                                        data-tooltip-trigger="click"
                                                        type="button"
                                                        onMouseEnter={() => {
                                                            setTimeout(() => {
                                                                setRevisedValuehoverId(prod.INVENTORY_ITEM_ID);
                                                            }, 100);
                                                        }}
                                                        onMouseLeave={() => {
                                                            setTimeout(() => {
                                                                setRevisedValuehoverId('');
                                                            }, 2000);
                                                        }}
                                                    >
                                                        <img src="/images/info-filled_icon.svg" alt="icon" className="cursor-pointer w-[14px] h-[14px]" />
                                                    </button>
                                                    {
                                                        revisedValuehoverId === prod.INVENTORY_ITEM_ID && (
                                                            <ItemPriceTooltip hover={revisedValuehoverId === prod.INVENTORY_ITEM_ID} prod={prod} itemPriceValue={((Number(prod?.sub_total) - Number(prod?.discount_applied)) - Number(prod?.revised_total_price)) / prod.quantity} />
                                                        )
                                                    }
                                                    <ItemPriceTooltip prod={prod} itemPriceValue={((Number(prod?.sub_total) - Number(prod?.discount_applied)) - Number(prod?.revised_total_price)) / prod.quantity} />
                                                </span>
                                            </div>
                                        </button>
                                    </div>
                                )}
                        </div>
                    )}
                </div>

            </div>
            {/* <LineItemsOrderStatus /> */}
            <ReactModal isOpen={addressPopup}>
                <AddressChangeModal
                    prod={prod}
                    addressPopup={addressPopup}
                    setaddressPopup={setaddressPopup}
                    OrderDetails={OrderDetails}
                    setOrderDetails={setOrderDetails}
                    addressDropdown={addressDropdown}
                    GroupCategory={GroupCategory}
                    setaddresmodal={setaddresmodal}
                    handleUpdateAddress={handleUpdateAddress}
                />
            </ReactModal>
        </div>
    );
}
